import { A } from "@solidjs/router";

export default function About() {
  return (
    <main class="text-center mx-auto text-gray-700 p-4">

      <h2 class="max-6-xs text-6xl text-sky-700 font-thin uppercase my-16">About Genie Cloud Dashboard</h2>
      
      <p class="mt-8">
        ToDo: Add some useful instructions!
      </p>
    </main>
  );
}
